import React from 'react';
import PropTypes from 'prop-types';
import { GridThemeProvider, BaseCSS } from 'styled-bootstrap-grid';

const theme = {
  row: {
    padding: 0,
    margin: 0,
  },
  col: {
    padding: 0,
    margin: 0,
  },
};

const GridTheme = ({ children }) => (
  <GridThemeProvider gridTheme={theme}>
    <BaseCSS />
    {children}
  </GridThemeProvider>
);

GridTheme.propTypes = {
  children: PropTypes.node.isRequired,
};

export default GridTheme;
